import * as React from 'react';
import { useSelector } from 'react-redux';
import { Text, Stack, StackChildren } from '@doordash/design-language';
import { AdminPageSubpageContentContainer } from '../AdminPage/AdminPageStyles';
import { TEAM_ACCOUNT_PAYMENT_METHOD } from '../../types/portal_data';
import track from '../../utils/track';
import { getSelectedTeamAccountPaymentInfo } from '../../selectors/teamAccountPaymentInfoSelector';
import { BillingTestId } from './testId';
import SelfServeEnabled from './SelfServeEnabled';
import PaymentStrings from './PaymentCard/PaymentStrings';
export var getPaymentMethodText = function (paymentMethod) {
    var baseString = "The current payment method is ";
    switch (paymentMethod) {
        case TEAM_ACCOUNT_PAYMENT_METHOD.DEFAULT_CARD:
            return baseString + ('credit card' + ".");
        case TEAM_ACCOUNT_PAYMENT_METHOD.INVOICING:
            return baseString + ('invoicing' + ".");
        case TEAM_ACCOUNT_PAYMENT_METHOD.UNKNOWN:
            return '';
        default:
            return '';
    }
};
export var AdminBilling = function () {
    var _a;
    React.useEffect(function () {
        track('workportal_view_payment_methods');
    }, []);
    var selectedTeamAccountPaymentInfo = useSelector(getSelectedTeamAccountPaymentInfo);
    var paymentMethod = (_a = selectedTeamAccountPaymentInfo === null || selectedTeamAccountPaymentInfo === void 0 ? void 0 : selectedTeamAccountPaymentInfo.paymentMethod) !== null && _a !== void 0 ? _a : TEAM_ACCOUNT_PAYMENT_METHOD.UNKNOWN;
    var paymentMethodCopy = getPaymentMethodText(paymentMethod);
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(StackChildren, { size: StackChildren.Sizes.Medium },
            React.createElement(StackChildren, { size: Stack.Sizes.XxxSmall, "data-testid": BillingTestId.Content },
                React.createElement(Text, { color: Text.Colors.TextPrimary, family: Text.Families.TtNorms, styles: Text.Styles.SectionTitleLarge, weight: Text.Weights.Medium }, "Payment Methods"),
                paymentMethod === TEAM_ACCOUNT_PAYMENT_METHOD.DEFAULT_CARD && (React.createElement(Text, { color: Text.Colors.TextSecondary }, PaymentStrings.paymentPageSubtitle()))),
            React.createElement(SelfServeEnabled, { paymentMethodCopy: paymentMethodCopy, paymentMethod: paymentMethod }))));
};
export default AdminBilling;
